// @ts-nocheck
import Sheet from 'atoms/sheet/sheet';
import * as dynamicGridSagaActions from 'models/dynamicGrid/sagaActions';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';
import * as tableColumnSagaActions from 'models/tableColumns/sagaActions';
import * as tableColumnSelectors from 'models/tableColumns/selector';
import SideCar from 'molecules/sidecar/sidecar';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import CustomizeViewModal from 'organisms/CustomizeViewModal';
import ThetaMenu from 'organisms/thetaMenu/thetaMenu';
import UploadData from 'organisms/uploadData';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ThetaGridPaginated from 'templates/thetaGridPaginated';
import * as constants from './constants';
import Breadcrumbs from 'atoms/breadcrumbs/breadcrumbs';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import GridActionBar from 'atoms/GridActionBar';
import GridCsvUpload from 'organisms/uploadData/gridCsvUpload';
import { getAclRole, isAclUsersReadWriteEnabled, isNewUploadEnabled } from 'models/user/selector';
import Button from 'atoms/button/button';
import { CreateUser } from './components/createUser';
import { triggerActivateUser, triggerDeactivateUser, triggerDeleteUser } from './sagaActions';
import { triggerFetchAutoComplete } from 'models/autoComplete/sagaActions';
import { Space, Tag, Switch, Tooltip } from 'antd';
import { fetchBookmarksList } from 'models/bookmarks/sagaActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { Button as AntButton } from 'antd';
import ThetaDeleteModal from 'organisms/deleteModal/deleteModal';

const getColumns = ({ onEditRow, onRemoveUserRole, onDeactivateUser, onActivateUser }) => [
	{
		title: 'User Name',
		// dataIndex: 'name',
		key: 'UserName',
		displayName: 'User Name',
		render: (obj) => obj.UserName,
	},
	{
		title: 'User Email',
		// dataIndex: 'name',
		key: 'UserEmail',
		displayName: 'User Name',
		render: (obj) => obj.UserEmail,
	},
	{
		title: 'Roles',
		// dataIndex: 'name',
		key: 'Roles',
		displayName: 'Roles',
		width: '30%',
		render: (obj) => (
			<Stack isWrap gutter="medium">
				{_.map(obj.Roles, (r) => (
					<StackItem>
						<Tag closable onClose={() => onRemoveUserRole(obj, r)}>
							{r.RoleName}
						</Tag>
					</StackItem>
				))}
			</Stack>
		),
	},
	{
		title: 'Status',
		// dataIndex: 'name',
		key: 'Status',
		displayName: 'Status',
		width: '10%',
		render: (obj) => (
			<Stack isWrap gutter="medium">
				{obj.IsActive ? 'Active' : 'Inactive'}
			</Stack>
		),
	},
	{
		title: 'Action',
		key: 'action',
		render: (obj) => (
			<Space size="middle">
				{obj.IsActive && <a onClick={() => onEditRow(obj)}>Edit</a>}

				{obj.IsActive ? (
					<a onClick={() => onDeactivateUser(obj)}>Deactivate</a>
				) : (
					<a onClick={() => onActivateUser(obj)}>Activate</a>
				)}
			</Space>
		),
	},
];
let debounce;

const Users: React.FunctionComponent = (props) => {
	const [openFilter, setOpenFilter] = React.useState<boolean>();
	const [isUploadEnabled, toggleUpload] = React.useState<boolean>(false);
	// const [isDeleteModal, toggleDeleteModal] = React.useState(false);
	const gridMeta = useSelector((state) => dynamicGridSelectors.getGridMetadata(state, constants.TABLE_ID));
	const [createUserInfo, setCreateUser] = React.useState(null);
	const tableId = constants.TABLE_ID.toString();
	const dispatch = useDispatch();
	const hasWriteAccess = useSelector(isAclUsersReadWriteEnabled);
	const hasDeleteAccess = useSelector;
	const hasSearchFilters = useSelector((state) => dynamicGridSelectors.hasSearchFilters(state, constants.TABLE_ID));

	const isCustomizeViewModalEnabled = useSelector((state) => tableColumnSelectors.isCustomizeViewModalEnabled(state));
	const [deleteModalOpen, setDeleteModalOpen] = React.useState<boolean>(false);

	const aclRole = useSelector((state) => getAclRole(state));

	const role = aclRole.find((r) => r === 'Admin');

	const fetchAllUsers = (search) => {
		dispatch(
			triggerFetchAutoComplete({
				componentId: 'acl-all-users',
				options: {
					service: 'acl',
					url: 'users/list',
					displayKey: 'UserName',
					selectionKey: 'UserID',
				},
				params: { search, fieldGroups: ['Roles', 'UserEmail'] },
			})
		);
	};
	useEffect(() => {
		dispatch(
			triggerFetchAutoComplete({
				componentId: 'acl-roles',
				options: {
					service: 'acl',
					url: 'roles/list',
					body: {
						IsActive: true,
					},
					displayKey: 'RoleName',
					selectionKey: 'RoleID',
				},
			})
		);
		fetchAllUsers();
	}, []);

	React.useEffect(() => {
		if (openFilter === undefined) {
			setOpenFilter(hasSearchFilters);
		}
	}, [hasSearchFilters]);

	React.useEffect(() => {
		dispatch(dynamicGridSagaActions.erpEnabled({ tableId: constants.TABLE_ID }));
		dispatch(fetchBookmarksList({ tableId: constants.TABLE_ID }));
	}, [dispatch]);

	const handleRefreshClick = React.useCallback(() => {
		dispatch(
			dynamicGridSagaActions.refreshGridData({
				tableId: constants.TABLE_ID,
			})
		);
	}, [tableId, dispatch]);

	const handleResetTableColumns = React.useCallback(async () => {
		dispatch(tableColumnSagaActions.resetTableColumnsAg(constants.TABLE_ID));
	}, [dispatch, tableId]);

	const customizeViewHandler = React.useCallback((isCustomizeViewModalEnabled: boolean) => {
		dispatch(tableColumnSagaActions.setCustomizeViewModal(isCustomizeViewModalEnabled));
	}, []);

	const onRemoveUserRole = (user, role) => {
		dispatch(triggerRemoveUserRole({ userId: user?.UserID, roles: [role?.RoleID] }));
	};
	const onDeactivateUser = (user) => {
		dispatch(triggerDeactivateUser({ userId: user?.UserID }));
		setTimeout(() => {
			dispatch(
				dynamicGridSagaActions.refreshGridData({
					tableId: constants.TABLE_ID,
				})
			);
		}, 2000);
	};

	const onActivateUser = (user) => {
		dispatch(triggerActivateUser({ userId: user?.UserID }));
		setTimeout(() => {
			dispatch(
				dynamicGridSagaActions.refreshGridData({
					tableId: constants.TABLE_ID,
				})
			);
		}, 2000);
	};

	const onEditRow = (row) => {
		setCreateUser(row);
	};

	const handleMenuItemClick = React.useCallback(
		(option: string) => {
			switch (option) {
				case constants.MENU_ITEMS_VALUES.CUSTOMIZE_VIEW:
					return customizeViewHandler(true);
				case constants.MENU_ITEMS_VALUES.RESET_VIEW:
					return handleResetTableColumns();
				case constants.MENU_ITEMS_VALUES.UPLOAD_DATA:
					return toggleUpload(true);
				// case constants.MENU_ITEMS_VALUES.DELETE:
				//   return deleteItems();
				default:
					return;
			}
		},
		[handleResetTableColumns]
	);

	const selectedItems = useSelector((state) => dynamicGridSelectors.getTableSelection(state, constants.TABLE_ID));
	const getDisabledStatus = React.useCallback(
		(option: any) => {
			switch (option.value) {
				case constants.MENU_ITEMS_VALUES.CUSTOMIZE_VIEW:
				case constants.MENU_ITEMS_VALUES.RESET_VIEW:
				case constants.MENU_ITEMS_VALUES.UPLOAD_DATA:
					return false;
				case constants.MENU_ITEMS_VALUES.DELETE:
					return !selectedItems?.selectedRowKeys?.length;
				default:
					return true;
			}
		},
		[selectedItems]
	);

	const hideCustomizeViewModal = React.useCallback(() => {
		customizeViewHandler(false);
	}, []);

	const uploadCloseClickHandler = React.useCallback(() => {
		toggleUpload(false);
	}, []);

	// const handleBulkDeleteClick = () => {
	//   dispatch(
	//     dynamicGridSagaActions.handleBulkRowDelete({
	//       tableId: constants.TABLE_ID,
	//     })
	//   );
	//   toggleDeleteModal(false);
	// };

	// const deleteItems = () => {
	//   toggleDeleteModal(true);
	// };

	const isNewUpload = useSelector(isNewUploadEnabled);

	const handleDeleteClick = (user: any) => {
		setCreateUser(user);
		setDeleteModalOpen(true);
	};

	const hideDeleteModal = () => {
		setDeleteModalOpen(false);
		setCreateUser(null);
	};

	const gridConfig = {
		enableSelection: true,
		enableSorting: true,
		enableMultiSort: true,
		gridActions: hasDeleteAccess,
		customActions: (hasWriteAccess || hasDeleteAccess) && {
			width: 170,
			enabled: true,
			component: ({ row }) => {
				// if (!usersList) return null;
				// const user = usersList.find(user => user.UserID === row.UserID);
				// if (!user) return null;

				if (!role) return null;

				return (
					<Stack gutter="small" align="center" position="center" className="tbl-action-buttons">
						{row.IsActive && (
							<StackItem className="tbl-action-buttons">
								<Button handleClick={() => onEditRow(row)}>
									{' '}
									<i className="icon-edit" />
								</Button>
							</StackItem>
						)}
						<StackItem>
							{/* {row.IsActive ? (
                <Button
                  type="secondary"
                  handleClick={() => onDeactivateUser(row)}
                >
                  Deactivate
                </Button>
              ) : (
                <Button
                  type="secondary"
                  handleClick={() => onActivateUser(row)}
                >
                  Activate
                </Button>
              )} */}
							{/* <Switch
                  checked={isGroupEnabled}
                  onChange={handleUpdateParameterGroup}
                  disabled={!hasParametersWrite}
                /> */}
							<Switch
								size="small"
								checked={row.IsActive}
								onChange={() => (row.IsActive ? onDeactivateUser(row) : onActivateUser(row))}
							/>
						</StackItem>
						<StackItem>
							<Button type="secondary" handleClick={() => handleDeleteClick(row)}>
								<i className="icon-trash" />
							</Button>
						</StackItem>
					</Stack>
				);
			},
		},
		selectionCallBack: () => {},
	};

	const handleUserDelete = () => {
		if (createUserInfo) {
			dispatch(
				triggerDeleteUser({
					UserID: createUserInfo.UserID,
					UserEmail: createUserInfo.UserEmail,
				})
			);
			hideDeleteModal();
		}
	};

	const templateConfig = {
		gridConfig,
		isFilterEnabled: openFilter === undefined ? false : openFilter,
		tableId: constants.TABLE_ID,
		dataProviderOptions: {
			type: 'POST',
			...REQUESTS.POST.GET_MONGO_GRID_DETAILS_V2,
			pathParams: { tableId: constants.TABLE_ID },
			version: 2,
		},
		selectRowKey: 'UserID',
	};

	const columns = getColumns({
		onEditRow,
		onDeactivateUser,
		onRemoveUserRole,
		onActivateUser,
	});

	return (
		<>
			<Stack isVertical>
				<StackItem>
					<GridActionBar>
						<div className="content-head">
							<Stack gutter="medium" align="space-between">
								<div className="content-head-lt">
									<Breadcrumbs crumbs={props.breadcrumbs} />
								</div>
								<div className="content-head-rt">
									<Stack gutter="medium" className="action-btns">
										<StackItem className="action-btn">
											<Button isPrimary handleClick={() => setCreateUser(true)}>
												Create User
											</Button>
										</StackItem>
										{isNewUpload && gridMeta?.UploadTableID && (
											<StackItem className="action-btn">
												<GridCsvUpload
													uploadTableId={gridMeta?.UploadTableID}
													parentTableId={tableId}
												/>
											</StackItem>
										)}
										<StackItem className="action-btn">
											<Tooltip title="Refresh">
												{' '}
												<AntButton
													className="menu-action--button"
													icon={
														<FontAwesomeIcon className="font-icon" icon={faArrowsRotate} />
													}
													onClick={handleRefreshClick}
												/>
											</Tooltip>
										</StackItem>
										<StackItem className="action-btn">
											<Tooltip title="More Options">
												{' '}
												<ThetaMenu
													type="3Dots"
													options={
														hasWriteAccess
															? constants.MENU_ITEMS
															: [constants.MENU_ITEMS[0]]
													}
													handleItemClick={handleMenuItemClick}
													isDisabled={getDisabledStatus}
												/>
											</Tooltip>
										</StackItem>
									</Stack>
								</div>
							</Stack>
						</div>
					</GridActionBar>
				</StackItem>
				<StackItem isStretch isGrow>
					<Sheet isPage className="order-tbl">
						<Stack isVertical gutter="medium">
							<StackItem isGrow isStretch>
								<ThetaGridPaginated key={constants.TABLE_ID} config={templateConfig} />
							</StackItem>
						</Stack>
					</Sheet>
				</StackItem>
			</Stack>

			{createUserInfo && columns && !deleteModalOpen && (
				<CreateUser userInfo={createUserInfo} onHide={() => setCreateUser(false)} />
			)}

			{isCustomizeViewModalEnabled && (
				<CustomizeViewModal hideModal={hideCustomizeViewModal} tableId={constants.TABLE_ID} />
			)}
			{isUploadEnabled && (
				<SideCar isActive={isUploadEnabled} handleOnClose={uploadCloseClickHandler}>
					<UploadData tableId={tableId} />
				</SideCar>
			)}
			{deleteModalOpen && (
				<ThetaDeleteModal
					hideModal={hideDeleteModal}
					modalTitle={'User'}
					title={createUserInfo?.UserName}
					handleDeleteClick={handleUserDelete}
				/>
			)}
		</>
	);
};
export default Users;
